import { Component, Input, OnInit } from '@angular/core';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-notificacion',
  templateUrl: './notificacion.component.html',
  styleUrls: ['./notificacion.component.css']
})
export class NotificacionComponent implements OnInit {

  @Input() notificacion;
  @Input() numeromensajes;
  
  idNotificacion: string;
  datosNotificacion: any;
  datosEmisor: any = { avatar: '', name: '', last_name: '' };

  // url = '';
  constructor(
    private userServices: UserService,
    private notificacionesService: NotificacionesService
  ) {}

  ngOnInit() {
    this.datosEmisor.avatar = '';
    this.datosNotificacion = this.getNotificationData();
    console.log(this.datosNotificacion)
    this.idNotificacion = this.getNotificationId();
    this.userServices
      .getUserById(this.datosNotificacion.sender_id)
      .subscribe((data) => {
        if (!data[0]) {
          return;
        }
        this.datosEmisor = data[0].payload.doc.data();
      });

    // if (
    //   this.datosNotificacion.mensaje == true
    // ) {
    //   this.url = this.datosNotificacion.url;
    // } else {
    //   // this.url = '/dashboard/profile/'+this.+'/miseventos';
    // }
  }

  deletenotificacion() {
    if (!this.idNotificacion) {
      return;
    }

    this.notificacionesService
      .removeNotificacion(this.idNotificacion)
      .then((data) => {});
  }

  getNotificationData(): any {
    return this.notificacion?.payload?.doc?.data?.() || this.notificacion || {};
  }

  getNotificationId(): string {
    return this.notificacion?.payload?.doc?.id || this.notificacion?.id || '';
  }

  getNotificationContent(): string {
    return this.datosNotificacion?.content || '';
  }

  getNotificationUrl(): string {
    return this.datosNotificacion?.url || '';
  }

  vernotificacion(uid) {
    const update = {
      seen: true,
    };
    this.notificacionesService
      .updateNotificacion(uid, update)
      .then((data) => {});
  }
}
